import type { ServiceOrderState } from '@horology/shared-types';

export const ALLOWED_TRANSITIONS: Record<ServiceOrderState, ServiceOrderState[]> = {
  INTAKE: ['DIAGNOSIS', 'CANCELLED'],
  DIAGNOSIS: ['QUOTE', 'CANCELLED'],
  QUOTE: ['IN_REPAIR', 'CANCELLED', 'ABANDONED'],
  IN_REPAIR: ['QUALITY_CHECK', 'CANCELLED'],
  QUALITY_CHECK: ['READY', 'IN_REPAIR'],
  READY: ['DELIVERED', 'ABANDONED'],
  DELIVERED: [],
  CANCELLED: [],
  ABANDONED: ['DELIVERED'],
};

export const STATE_LABELS: Record<ServiceOrderState, string> = {
  INTAKE: 'Ingreso',
  DIAGNOSIS: 'Diagnóstico',
  QUOTE: 'Presupuesto',
  IN_REPAIR: 'En Reparación',
  QUALITY_CHECK: 'Control de Calidad',
  READY: 'Listo',
  DELIVERED: 'Entregado',
  CANCELLED: 'Cancelado',
  ABANDONED: 'Abandonado',
};

export const STATE_ORDER: ServiceOrderState[] = [
  'INTAKE',
  'DIAGNOSIS',
  'QUOTE',
  'IN_REPAIR',
  'QUALITY_CHECK',
  'READY',
  'DELIVERED',
];

export const STATE_COLORS: Record<ServiceOrderState, string> = {
  INTAKE: '#6b7280',
  DIAGNOSIS: '#0ea5e9',
  QUOTE: '#f59e0b',
  IN_REPAIR: '#8b5cf6',
  QUALITY_CHECK: '#06b6d4',
  READY: '#10b981',
  DELIVERED: '#1a1a1a',
  CANCELLED: '#dc2626',
  ABANDONED: '#a16207',
};
